export default "__VITE_ASSET__BoNklLem__"